module.exports = __webpack_public_path__ + "static/media/535.f7e01c97.webp";